import React from 'react';
import { compose, lifecycle, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { Column, Grid } from '../../../components/layout/grid';
import { Component as BaseArticles } from '../../dashboard/widgets/content/component';
import { getFeaturedArticles } from '../../../store/reducers/content';

import styles from '../../../styles/templates/custom-page/featured-articles.module.scss';

export const Component = React.memo(props => {
  const { header, subHeader, content, button } = props;

  return (
    <Grid className={styles.container}>
      <Column className={styles.cards}>
        <BaseArticles title={header} subtitle={subHeader} content={content} button={button} />
      </Column>
    </Grid>
  );
});

const mapStateToProps = state => ({
  content: state.content.featuredArticles,
  loading: state.content.loadingFeaturedArticles
});

export const FeaturedArticles = compose(
  connect(mapStateToProps, { getFeaturedArticles }),
  lifecycle({
    async componentDidMount() {
      const { blockTags, getFeaturedArticles } = this.props;

      await getFeaturedArticles(blockTags);
    }
  }),
  branch(({ loading }) => loading, renderNothing)
)(Component);
